import { SafePromise } from '@benzinga/safe-await';
import { Subscribable, Subscription } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';
import { Event } from './entities';
import { EventsRequest, EventsRestfulEvent } from './request';

export type EventsManagerEvent = EventsRestfulEvent;

export class EventsManager extends Subscribable<EventsManagerEvent> {
  private request: EventsRequest;
  private requestSubscription?: Subscription<EventsRequest>;

  constructor(session: Session) {
    super();
    this.request = new EventsRequest(session);
  }

  public static getName = () => 'benzinga-events';

  getEvent = async (postId: number): SafePromise<Event> => {
    return await this.request.getEvent(postId);
  };

  getEvents = async (): SafePromise<Event[]> => {
    return await this.request.getEvents();
  };

  protected onFirstSubscription(): void {
    this.requestSubscription = this.request.listen(event => this.dispatch(event));
  }

  protected onZeroSubscriptions(): void {
    this.requestSubscription?.unsubscribe();
  }
}
